module.exports = {
  loading: 'memuat',
  logout: 'Keluar',
  logoutDesc: 'Apakah Anda yakin ingin keluar?',
  check: 'Periksa',
  asntitle: 'Waktunya QUizZZ',
  asntitle2: 'Sisa Kuis',
  Correct: 'Benar',
  wrong: 'SALAH',
  ansTitle1: 'Luar Biasa!',
  ansTitle2: 'Anda masih memiliki ',
  ansTitle22: 'kartu untuk jawaban yang salah ini!',
  ansTitle3: 'Hampir saja!',
  congratulations: 'Selamat!',
  otp: 'otp',
  ladingpageTips: '(Gratis dari 9 Jan - 7 Feb)',
  ladingpageTips2: 'Hanya untuk Pengguna Baru!',
  Daily: 'Harian',
  dailyM: 'Rp 1.110',
  Weekly: 'Mingguan',
  weeklyM: 'Rp 1110',
  Monthly: 'Bulanan',
  monthlyM: 'Rp 1110',
  subscribeNow: 'Berlangganan',
  Copyright: 'Hak Cipta © Grab&Get 2026',
  CopySucceeded: 'Berhasil disalin',
  play: 'pilih saya',
  myAccount: 'Info pribadi',
  profile: 'Profil',
  FAQs: 'Tanya Jawab',
  TC: 'S&K',
  language: 'Bahasa',
  PickLanguage: 'Pilih Bahasa',
  Submit: 'Kirim',
  change: 'ubah',
  English: 'Inggris',
  showMore: 'Lihat Lebih Banyak',
  Login: 'Masuk',
  Logout: 'Keluar',
  getCode: 'Kirim Ulang',
  phoneNumber: 'NOMOR TELEPON',
  enderNumber: 'Masukkan nomor telepon',
  Name: 'nama pengguna',
  address: 'Alamat',
  phone: 'Telepon',
  Prize: 'Hadiah',
  referral: 'Undang teman',
  winnerList: 'Daftar Pemenang',
  Date: 'Tanggal',
  Save: 'Simpan',
  cancel: 'batal',
  Confirm: 'Konfirmasi',
  goBack: 'kembali',
  No: 'Tidak',
  OK: 'OK',
  Yes: 'Ya',
  UNSUBSCRIBE: 'BERHENTI BERLANGGANAN',
  noMore: 'Tidak ada lagi',
  more: 'Lebih banyak',
  ohNo: 'Oh Tidak',
  subDes2: 'Kami sedih melihat Anda pergi!',
  des2: 'Apakah Anda yakin ingin berhenti berlangganan?',
  boxes: 'TOTAL Skor',
  box: 'Total Kartu',
  referralTips1: "Undang pengguna baru untuk mendapatkan hadiah. 1000 Skor akan diberikan kepada pengundang dan yang diundang.",
  memberGetMember: 'member-get-member',
  referralTips2: 'Ini adalah ID referal Anda',
  referralTips3: 'Ini adalah ID referal teman Anda',
  Status: 'Status',
  noFound: 'Oops! <br />Hasil tidak ditemukan!',
  cgtips1: 'MENANGKAN HADIAH UTAMA !!!',
  cgtips2: 'Hanya Rp 1110/hari,<br />silakan klik OK untuk berlangganan.',
  cgtips2W: 'Hanya Rp 2220/2 hari,<br />silakan klik OK untuk berlangganan.',
  indexbutton1: 'Pilih Game',
  getMorecards: 'untuk mendapatkan lebih banyak skor',
  indexbutton2: 'pilih 9x kali',
  landFont1: 'Masukkan nomor telepon',
  landFont2: 'Pilih paket',
  landingFont: 'Biaya berlangganan akan dipotong dari saldo utama.',
  optTips: 'Anda sudah berlangganan, silakan klik OK untuk mendapatkan kode masuk',
  landingContent: '<div class="ac">Syarat & Ketentuan Umum Mytel</div><br />1. Layanan dapat digunakan selama 365 hari dengan biaya harian/mingguan/bulanan berdasarkan tipe layanan yang Anda pilih.<br /><br />2. Mytel mengumpulkan biaya berdasarkan frekuensi penggunaan layanan (misalnya, tanpa perpanjangan atau harian) atau metode cicilan (misalnya tagihan mingguan/bulanan berdasarkan 365 hari layanan).<br /><br />3. Jika mitra Mytel (pihak ketiga) menyediakan masa percobaan, pelanggan dapat menikmati masa percobaan tersebut hingga tanggal kedaluwarsa. Setelah itu, biaya akan dikenakan sesuai layanan yang dipilih. Saldo ponsel Anda akan terpotong untuk biaya harian/mingguan/bulanan. Dengan mengakses layanan, Anda mengakui dan menerima biaya tersebut sesuai Syarat Layanan ini.<br /><br />4. Dengan mengeklik langganan, Anda menerima Syarat dan Ketentuan Layanan yang digunakan.',
  Invitation_Link: 'Ini adalah tautan undangan Anda',
  Copy: 'Salin',
  Invitation_Count: 'Jumlah Undangan',
  homeTotal1: 'Kesempatan Bermain Anda',
  homefont2: 'Buka kartu keberuntunganmu untuk memenangkan HADIAH BESAR.',
  buyPack: 'Beli Paket',
  buyNow: 'Beli Sekarang',
  buyContent: 'Beli paket 1 kesempatan bermain untuk mendapatkan lebih banyak skor',
  luckyTips1: 'Setiap kartu memiliki kesempatan untuk memenangkan hadiah berikut.',
  alertTips: 'Anda telah berhasil mengundang pengguna berikut:',
  personalInfo: 'Info Pribadi',
  invitation_log: 'Riwayat Undangan',
  ruleTask: 'Aturan Tugas',
  DailyLogin: 'Login Harian',
  DailyLoginT1: 'Masuk setiap hari untuk membuka hadiah menarik! Semakin sering Anda masuk, semakin bagus hadiahnya!',
  Claim: 'Ambil',
  Missed: 'Terlewat',
  ReClaim: 'Ambil Lagi',
  DailyLoginT2: 'Ambil Hadiah yang Terlewat!',
  DailyLoginT3: 'Hanya dengan Rp 1110, Anda dapat mengambil hadiah yang terlewat.',
  yesClaim: 'Ya, Ambil',
  indexbutton12: 'Tersedia Tanpa Batas!',
  game_list: 'Pilih Mini Games',
  Play: 'Main',
  Easy: 'Mudah',
  Medium: 'Sedang',
  Hard: 'Sulit',
  Level: 'Level',
  ChooseTips1: 'Pilih Level 1, 2, atau 3. <br />Semakin tinggi level, semakin besar peluang menang!',
  total_starts: "TOTAL Skor",
  'Stars': 'Skor',
  'Ranking': 'Peringkat',
  'Packs': 'Paket',
  pkfont1: 'Paket Sekali Beli',
  pkfont2: 'Pembelian Sekali',
  pkfont3: 'Tambahan 1 Kesempatan Bermain',
  pkfont4: 'Rp 1110',
  pkfont21: 'VIP Royal Kit',
  pkfont22: 'Untuk 30 Hari',
  pkfont23: '5 Kesempatan / hari, 200 Skor / hari, Logo & Frame VIP',
  pkfont24: 'Rp 2220',
  pkfont31: 'Paket 2 hari',
  pkfont32: 'Untuk 2 hari',
  pkfont41: 'Paket Harian',
  pkfont42: 'Langganan Harian',
  pkfont43: '1 Kesempatan / hari',
  'Invitation successful!': 'Undangan berhasil!',
  invitTips1: 'Anda mendapatkan \'1000 Skor\' karena mengundang pengguna baru!',
  'Card Name': 'Nama Kartu',
  'Thank You': 'Terima Kasih',
  'no prize found': 'hadiah tidak ditemukan',
  "Better luck next time!": 'Semoga lebih beruntung lain kali!',
  LvL_1: 'LvL 1',
  LvL_2: 'LvL 2',
  LvL_3: 'LvL 3',
  level_tip1: "Buka kartu 'LvL 1' dengan '100 Skor' untuk menang HADIAH BESAR.",
  level_tip2: "Buka kartu 'LvL 2' dengan '200 Skor' untuk menang HADIAH BESAR.",
  level_tip3: "Buka kartu 'LvL 3' dengan '300 Skor' untuk menang HADIAH BESAR.",
  indexbutton3: 'Beli Lebih Banyak Kesempatan',
  loginTips: "Masukkan nomor telepon",
  accountLabel: 'Akun',
  passwordLabel: 'Kata Sandi',
  accountPlaceholder: 'Masukkan akun',
  passwordPlaceholder: 'Masukkan kata sandi',
  accountLoginTips: 'Masukkan akun',
  passwordLoginTips: 'Masukkan kata sandi',
  noAccountGoRegister: 'Belum punya akun? Ke daftar',
  hasAccountGoLogin: 'Sudah punya akun? Ke login',
  upload_fail: "Gagal mengunggah",
  home_prize_tip: "Mainkan Game dan coba keberuntunganmu menang hadiah besar!",
  buy_popup_tip1: "Beli Lebih Banyak Kesempatan",
  buy_popup_tip2: "Ketuk 'Beli Sekarang' untuk beli tambahan kesempatan game seharga Rp 1.110",
  Guidance: 'Panduan',
  Subscribe: 'Berlangganan',
  DailyKyats: '149 Kyats',
  WeeklyKyats: '599 Kyats',
  OneTime: 'Sekali Beli',
  Purchase: 'Pembelian',
  OneTimeChance: 'Rp 1.110',
  lucky_draw: 'Undian Berhadiah',
  yearly_list: 'Pemenang Tahunan',
  month_list: 'Pemenang Bulanan',
  week_list: 'Pemenang Mingguan',
  daily_tip: "1 kali Kesempatan Bermain",
  weekly_tip: 'Keuntungan: <br /> Terima 4 kesempatan bermain pada <br />hari pertama. <br /> Dapatkan 1 kesempatan untuk setiap <br /> enam hari berikutnya.<br />Total: 10 Kesempatan ',
  monthly_tip: 'Keuntungan: <br />5 Kesempatan bermain per hari<br />200 poin<br />Logo VIP Royal<br />Bingkai profil khusus VIP (berlaku selama <br />30 hari)',
  buy_tip: "Keuntungan: 1 Perubahan",
  daily_pack: "Paket 1 Hari",
  daily_2_pack:"Paket 2 hari",
  weekly_pack: "Paket Mingguan",
  monthly_pack: "Paket Bulanan",
  one_time_package: "Paket Sekali Beli",
  sub_tip: "Untuk mendaftar dengan mudah REG<spasi>GT1 Kirim ke 93827",
  unsub_tip: "Untuk membatalkan program UNREG<spasi>GT1 kirim ke 93827",
  GrabGet: 'Grab & Get',
  'Free Time': 'Waktu Gratis',
  'chance': 'kesempatan',
  'goGet': 'Ayo Ambil',
  'join_us': 'Anda juga dapat bergabung melalui "615"',
  'avatar': 'Avatar',
  "daily_2_tip":"2 kali kesempatan Bermain",
  "daily_2_M":"Rp 2.220",
   Yearly: 'Tahunan',
  "1_day":" Paket Harian",
  "2_day":"Paket 2 hari",

}



// WEBPACK FOOTER //
// ./src/assets/i18n/bur.js